if (!customElements.get('round-category-navigation')) {
  customElements.define('round-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.track = this.querySelector('.wp-round-categories__track');
      this.controls = this.querySelector('.wp-round-categories__controls');
      this.previous = this.querySelector('[data-round-previous]');
      this.next = this.querySelector('[data-round-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.scrollTo(0);
        else if (event.key === 'End') this.scrollTo(this.rtl ? -this.max : this.max);
        else this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.wp-round-categories__item');
        if (!item || !this.contains(item)) return;
        this.reveal(item);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.track.querySelectorAll('.wp-round-categories__item').forEach((item) => this.observer.observe(item));
      this.update();
      const active = this.track.querySelector('[aria-current="page"]')?.closest('.wp-round-categories__item');
      if (active) requestAnimationFrame(() => { if (this.isConnected) this.reveal(active, false); });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    update() {
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= this.max - 1;
      this.controls.hidden = this.max <= 1;
    }

    move(direction) {
      const items = this.track.querySelectorAll('.wp-round-categories__item');
      if (items.length < 2) return;
      const step = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
      this.scrollTo(this.track.scrollLeft + direction * (this.rtl ? -1 : 1) * step);
    }

    scrollTo(left, animate = true) {
      this.track.scrollTo({ left, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    }

    reveal(item, animate = true) {
      const trackBounds = this.track.getBoundingClientRect();
      const itemBounds = item.getBoundingClientRect();
      let adjustment = 0;
      if (itemBounds.left < trackBounds.left + 4) adjustment = itemBounds.left - trackBounds.left - 4;
      else if (itemBounds.right > trackBounds.right - 4) adjustment = itemBounds.right - trackBounds.right + 4;
      if (adjustment) this.scrollTo(this.track.scrollLeft + adjustment, animate);
    }
  });
}
